<template>
<div class="btn-group" data-toggle="buttons">
  <slot></slot>
</div>
</template>


<script>
export default {
  props: {
    values: {
      type: Array,
      default: [],
    }
  },
}
</script>



// WEBPACK FOOTER //
// checkbox-group.vue?3a0ab854